<template>
  <phone-calls-tab
    :linked-calls="linkedCalls"
    :filters="filters"
    linkable-type="Job"
    :linkable-id="job.id"
    @link-call="handleLinkCall"
  ></phone-calls-tab>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import PhoneCallsTab from "@/CallComponents/PhoneCallsTab.vue";

export default {
  components: {
    PhoneCallsTab
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      job: "job",
      linkedCalls({ job }) {
        if (!job) {
          return [];
        }
        return job.linked_calls;
      }
    })
  },
  mounted() {
    EventBus.$on("refresh-linked-calls", this.reloadJob);
  },
  beforeUnmount() {
    EventBus.$off("refresh-linked-calls", this.reloadJob);
  },
  methods: {
    ...mapActions(["linkCall", "fetchJob"]),
    handleLinkCall(callId) {
      const { links } = this.job;
      if (links.link_call) {
        this.linkCall({ link: links.link_call, call_id: callId }).then(() => {
          window.notify.success("Phone call was succesfully linked to job.");
          this.reloadJob();
          EventBus.$emit("refresh-datatable");
        });
      }
    },
    reloadJob() {
      this.fetchJob({ jobId: this.job.id });
    }
  }
};
</script>

<style lang="scss" scoped></style>
